export default __webpack_public_path__ + "static/media/swarmfighter.f356a08d.png";